






import vue from "vue";
import {
  VUEX_EXERCISE_ACTION_NAMES,
  VUEX_EXERCISE_GETTER_NAMES,
  VUEX_EXERCISE_NAMESPACE
} from "@tt-app/constants";

import ExerciseBody from "@tt-app/components/exerciseBase/ExerciseBody.vue";
import ExerciseLayout from "@tt-app/layouts/ExerciseLayout.vue";

const {
  EXERCISE_DETAILS_REQUEST,
  LOG_START,
  NAVIGATION_ATTEMPT,
  RESET_EXERCISE
} = VUEX_EXERCISE_ACTION_NAMES;
const { BODY } = VUEX_EXERCISE_GETTER_NAMES;

interface Methods {
  fetchExerciseDetails: () => void;
  startExercise: () => void;
}

interface Computed {
  assignmentId: string;
  courseUuid: string;
  inProgress: boolean;
  pageBody: any[];
  exerciseUuid: string;
}

export default vue.extend<any, Methods, Computed, any>({
  name: "ExerciseView",

  components: { ExerciseBody, ExerciseLayout },

  async created() {
    await this.fetchExerciseDetails();
    await this.startExercise();
  },

  beforeDestroy() {
    this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${RESET_EXERCISE}`);
  },

  beforeRouteLeave(_to, _from, next) {
    const limitedModeUpdated = _to.params.limitedMode === "true";

    this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${NAVIGATION_ATTEMPT}`, {
      limitedModeUpdated,
      next
    });
  },

  methods: {
    async fetchExerciseDetails() {
      await this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${EXERCISE_DETAILS_REQUEST}`, {
        assignmentId: this.assignmentId,
        courseUuid: this.courseUuid,
        exerciseUuid: this.exerciseUuid
      });
    },

    async startExercise() {
      await this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${LOG_START}`, {
        assignmentId: this.assignmentId
      });
    }
  },

  computed: {
    assignmentId() {
      return this.$route.params.assignmentId;
    },

    courseUuid() {
      return this.$route.params.courseUuid;
    },

    inProgress() {
      return this.$store.state.exercise.inProgress;
    },

    pageBody() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${BODY}`];
    },

    exerciseUuid() {
      return this.$route.params.exerciseUuid;
    }
  },

  watch: {
    inProgress: {
      handler(newValue) {
        window.onbeforeunload = null;

        if (newValue) {
          window.onbeforeunload = () => {
            return true;
          };
        }
      }
    }
  }
});
